module.exports = __webpack_public_path__ + "img/baizhi-back-four@3x.22d358c3.jpg";